import React, { useEffect, useMemo } from 'react'
import styles from './styles.module.css'
import Button from '../../components/Button'
import { IoIosAdd } from 'react-icons/io'
import { useNavigate } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { useState } from 'react'
import Modal from './Modal'
import Table from '../../components/Table'
import { BiTrash } from 'react-icons/bi'
import Confirmation from '../../components/Confirmation/Confirmation'
import { clearMethodAssoc, deleteMethodAssoc, getMethodAssoc, getMethodAssocById, getMethodAssocMids, getMethodAssocPeople } from '../../actions/methodAssoc'
export default function MethodologicalAssociation() {
  const dispatch = useDispatch()

  const { list, methodAssoc } = useSelector(state => state.method_assoc)

  const [selectedItem, setSelectedItem] = useState(null)
  const [confirmation, setConfirmation] = useState(false);
  const [sortAsc, setSortAsc] = useState(true)

  useEffect(() => {
    dispatch(getMethodAssoc())
    selectedItem?.maid && dispatch(getMethodAssocById(selectedItem.maid))
  }, [selectedItem])

  const sortedList = useMemo(() => {
    if (!list) return []
    return [...list].sort((a, b) => sortAsc
      ? a.levelname?.localeCompare(b.levelname, 'ru')
      : b.levelname?.localeCompare(a.levelname, 'ru'))
  }, [list, sortAsc])

  const openModal = (data) => () => {
    if (!data.maid) {
      dispatch(clearMethodAssoc())
    }
    setSelectedItem(data)
    data.maid && dispatch(getMethodAssocMids(data.maid))
    dispatch(getMethodAssocPeople())
  }

  const closeModal = () => setSelectedItem(null)

  const acceptConfirmation = () => {
    closeModal();
    dispatch(deleteMethodAssoc(confirmation.id));
    setConfirmation(false);
  };
  const rejectConfirmation = () => {
    setConfirmation(false);
  };

  const renderLi = (data) => {
    const { maid, levelname } = data
    return (
      <tr >
        <td onClick={openModal(data)}>{levelname}</td>
        <td><i className={styles.trash} onClick={() => setConfirmation({ id: maid, name: levelname })}><BiTrash /></i></td>
      </tr>
    )
  }

  return (
    <div className={styles.wrapper} style={{ width: '700px', margin: '0 auto' }}>
      {confirmation && (
        <Confirmation
          top="30px"
          left="40px"
          title={`Вы уверены, что хотите удалить ${confirmation.name}?`}
          acceptConfirmation={() => acceptConfirmation(confirmation?.name)}
          rejectConfirmation={rejectConfirmation}
        />
      )}
      {selectedItem &&
        <Modal
          closeModal={closeModal}
          data={selectedItem}
          height={'430px'}
          addMode={!selectedItem.maid}
        />
      }
      <h1>Методические объединения</h1>

      <Table className={styles.tables}>
        <thead>
          <tr>
            <th onClick={() => setSortAsc(v => !v)} style={{ cursor: 'pointer' }}>Название</th>
            <th></th>
          </tr>
        </thead>
        <tbody>
          {sortedList.map(renderLi)}
        </tbody>
      </Table>
      <div style={{ display: 'flex', flexDirection: "row" }}>
        <Button
          style={{ padding: '.5rem 1.5rem', margin: '12px' }}
          onClick={openModal({})}
        >
          <IoIosAdd size={30} />
          Добавить
        </Button>
      </div>
    </div>
  )
}